import Vue from "vue";
import vuexI18n from "vuex-i18n";
import axios from "axios";
import store from "./store";

Vue.use(vuexI18n.plugin, store,
{
    moduleName: "i18n",
    onTranslationNotFound (locale, key) {
    console.warn(`i18n :: Key "${key}" not found for locale "${locale}"`);
    return "???";
    }
});

export async function updateTranslations(cultureCode = "en")
{
  try
  {
    const response = await axios.get(`${process.env.VUE_APP_API_URL}/Utilities/Translations?cultureCode=${cultureCode}`);
    const translations = response.data;
    Vue.i18n.replace(cultureCode, translations);
  }

  catch(error)
  {

  }

  document.cookie=`language=${cultureCode}`;
  Vue.i18n.set(cultureCode);
}